import React,{ useEffect, useState } from "react";

interface TimeProps {
    startTime:number;
    resetKey:number;
    onTImeEnd:()=>void;
}

const Time:React.FC<TimeProps> =({startTime,resetKey,onTImeEnd})=>{
        const [timeLeft ,setTimeLeft]= useState<number>(startTime);
        const [showButton,setShowButton]=useState(false);
    useEffect(()=>{
       const intervalId=setInterval(()=>{
        setTimeLeft((prevTime: number)=>{
            if(prevTime<=1){
                clearInterval(intervalId);
                onTImeEnd();
                return 0;
            }
            return prevTime-1;
        });
       },1000);
       return()=>clearInterval(intervalId);
    },[timeLeft,onTImeEnd]);
    useEffect(()=>{
        setTimeLeft(startTime);
    },[resetKey,startTime]);

    const formatTime=(seconds:number):string=>{
        const minutes=Math.floor(seconds/60);
        const remainingSeconds=seconds=seconds%60;
        return `${minutes}:${remainingSeconds<10?'0':''}${remainingSeconds}`;
    }
    return <div>{formatTime(timeLeft)}</div>


}

export default Time;